module.exports = __webpack_public_path__ + "media/images/about-2-d07734397e3970d36689d5a8874e0b1f.png";